module.exports = __webpack_public_path__ + "static/media/alarm.0d84c4f1.svg";